/*
 * DR Vitamin — full-resolution product images on demand (2026-09-14, reworked 2026-10-05).
 *
 * The page image is sized for its box (550/1100/1445w), which is right for page speed. The fullscreen gallery that a
 * tap/click opens reused that same small file, so on desktop a 900px fullscreen view — and 2700px after
 * "Zoom(+/-)" — was an upscaled 1100px image, and "Save image" saved the 1100px copy. Measured 2026-09-14.
 *
 * Now, only when the customer opens the fullscreen gallery, the gallery images ask for the master (the largest
 * srcset entry, 1600px for the catalogue standard). The page itself still loads the small files. The theme's
 * English-only "Zoom(+/-)" control gets the page language and keyboard access.
 *
 * 2026-10-05: the ORDINARY save (iOS long-press, desktop "Save image as") now returns the original — see the
 * block at the foot of this file. The former "download original / view full size" button row is removed.
 */
(function () {
  var AR = /^ar/i.test(document.documentElement.lang || '');
  var TXT = AR
    ? { open: 'عرض الصورة بالحجم الكامل', zoom: 'تكبير / تصغير' }
    : { open: 'View full-size image', zoom: 'Zoom in / out' };

  function stripWidth(u) {
    return String(u || '').replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
  }

  /* The master URL, taken from whatever the element can tell us — including the largest srcset candidate, because a
     slide that has not been painted yet has no currentSrc at all. */
  function masterOf(img) {
    var explicit = img.getAttribute('data-zoom-image');
    if (explicit) return stripWidth(explicit);
    var best = '', bestW = -1;
    var set = img.getAttribute('srcset') || '';
    set.split(',').forEach(function (part) {
      var m = part.trim().match(/^(\S+)\s+(\d+)w$/);
      if (m && +m[2] > bestW) { bestW = +m[2]; best = m[1]; }
    });
    return stripWidth(best || img.currentSrc || img.getAttribute('src') || '');
  }

  /* 2026-09-18 (owner P0 "opening/downloading an image must give a high-resolution file"). Setting sizes=1600px was
     not enough, measured on the live theme:
       · only the slide that had been painted picked a bigger file; swiping to another slide and saving it still gave
         the 1445px rendition (2 of 5 slides on NOW Ultra Omega-3, 5 of 8 on NOW Iron);
       · a master larger than the theme's srcset list was capped — NatureBell TUDCA (2283px master) opened at 1680px.
     So inside the fullscreen dialog ONLY, every image is pointed straight at the master and srcset/sizes are dropped,
     which no longer leaves the choice to the browser. The page outside the dialog is untouched, so responsive
     delivery and page speed are unchanged. */
  function forceMasters(root) {
    var imgs = root.querySelectorAll('img.main-image');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.getAttribute('data-drv-master') === '1') continue;
      var m = masterOf(img);
      if (!m) continue;
      img.setAttribute('data-drv-master', '1');
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      if (img.getAttribute('src') !== m) img.setAttribute('src', m);
    }
  }

  function upgrade(root) {
    var imgs = root.querySelectorAll('.gallery-main img.main-image');
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].hasAttribute('data-drv-page-sizes')) continue;
      imgs[i].setAttribute('data-drv-page-sizes', imgs[i].getAttribute('sizes') || '');
      /* the largest srcset entry is the master; asking for 1600 CSS px selects it at any device pixel ratio */
      imgs[i].setAttribute('sizes', '1600px');
    }
  }

  /* capture phase: runs before the theme's own click handler opens the fullscreen dialog */
  document.addEventListener('click', function (e) {
    var slide = e.target.closest && e.target.closest('.gallery-main .swiper-slide[data-media_type="image"]');
    if (!slide || slide.closest('dialog')) return;
    upgrade(slide.closest('gallery') || slide.parentNode);
  }, true);

  function enhance(dialog) {
    forceMasters(dialog);
    var z = dialog.querySelector('.toggle-zoom');
    if (z && !z.hasAttribute('data-drv')) {
      z.setAttribute('data-drv', '');
      z.textContent = TXT.zoom;
      z.setAttribute('role', 'button');
      z.setAttribute('tabindex', '0');
      z.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); z.click(); }
      });
    }
  }

  /* the theme appends the dialog to <body>, then moves the gallery and its zoom control in once it has opened */
  new MutationObserver(function () {
    var d = document.querySelector('dialog.gallery-fullscreen');
    if (!d || d.__drvWatched) return;
    d.__drvWatched = true;
    enhance(d);
    /* childList: the gallery arrives; attributes on slides: the active slide changes */
    new MutationObserver(function () { enhance(d); }).observe(d, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }).observe(document.body, { childList: true });

  /* ------------------------------------------------------------------------------------------------
   * 2026-10-05 (owner: fix saving the image the ORDINARY way, not through extra buttons).
   *
   * WHAT THE BROWSER ACTUALLY SAVES, measured on the live PDP before this change:
   *   a long-press on iOS and "Save image as" on desktop both save `currentSrc` — the RESPONSIVE
   *   CANDIDATE the browser chose, not the master. On NOW L-Theanine at 1366x900 the active slide's
   *   currentSrc was `...?width=1100` while the original is 1600x1600, so the saved file lost 31% of
   *   its linear resolution and about half its pixels. The other three slides had NO currentSrc at
   *   all until painted, so saving those gave whatever the browser happened to fetch first.
   *
   * THE FIX IS THE ORDINARY SAVE, NOT A CONTROL: the ACTIVE slide's <img> is pointed at the original
   * and its srcset/sizes are removed, so `currentSrc` IS the original. A long-press or Save-image-as
   * then returns the original by definition, because there is no longer a smaller candidate to pick.
   *
   * data-zoom-image is the authority: the template emits it as `media.src | image_url` with NO width
   * parameter, it is present on every slide including unpainted ones, and it is same-origin.
   *
   * PAGE SPEED IS PROTECTED THREE WAYS, because the first gallery image is the LCP candidate:
   *   1. the first upgrade waits for window.load and then an idle callback, so it never competes with
   *      the LCP paint;
   *   2. only the ACTIVE slide is ever upgraded — never the whole gallery — so one original is
   *      fetched per image the customer actually looks at;
   *   3. the original is preloaded off-document and the visible src is swapped only once it has
   *      decoded, so there is no flash, no blank frame and no layout shift.
   * The page's own responsive srcset/sizes are kept in data attributes, so the change is reversible
   * per element and nothing is destroyed.
   *
   * THE ACTIVE SLIDE IS READ FROM THE SWIPER INSTANCE, WITH A GEOMETRIC FALLBACK. The page gallery
   * does NOT carry `swiper-slide-active` — only the fullscreen dialog does — so keying on that class
   * would have silently upgraded slide 0 forever and the owner's "active image, not just the first"
   * requirement would have failed quietly. Measured: gal.swiper.activeIndex agreed with an
   * independent overlap test, where the active slide overlaps the gallery box 100% and the others 0%.
   *
   * Nothing is upscaled and no image is altered: the bytes served are the ones Shopify stores.
   * ------------------------------------------------------------------------------------------------ */
  function absUrl(u) {
    u = String(u || '');
    if (!u) return '';
    return u.indexOf('//') === 0 ? location.protocol + u : u;
  }

  function originalOf(img) {
    var z = img.getAttribute('data-zoom-image');
    if (z) return absUrl(stripWidth(z));
    return absUrl(masterOf(img));
  }

  function activeSlideIn(gal) {
    var slides = [].slice.call(gal.querySelectorAll('.swiper-slide'));
    if (!slides.length) return null;
    var sw = gal.swiper;
    if (sw && typeof sw.activeIndex === 'number' && slides[sw.activeIndex]) return slides[sw.activeIndex];
    var box = gal.getBoundingClientRect(), best = null, bestOv = 0;
    for (var i = 0; i < slides.length; i++) {
      var r = slides[i].getBoundingClientRect();
      var ov = Math.max(0, Math.min(r.right, box.right) - Math.max(r.left, box.left));
      if (ov > bestOv) { bestOv = ov; best = slides[i]; }
    }
    return best;
  }

  var pending = null;   /* at most one original in flight at a time */
  var retry = null;     /* one shared retry timer, so a missed upgrade is never final */

  function hoistResponsive(img) {
    /* the responsive src is kept too: one attribute, and it keeps a revert possible without re-deriving it */
    if (!img.hasAttribute('data-drv-src') && img.getAttribute('src')) {
      img.setAttribute('data-drv-src', img.getAttribute('src'));
    }
    if (img.hasAttribute('srcset')) {
      img.setAttribute('data-drv-srcset', img.getAttribute('srcset'));
      img.removeAttribute('srcset');
    }
    if (img.hasAttribute('sizes')) {
      img.setAttribute('data-drv-sizes', img.getAttribute('sizes'));
      img.removeAttribute('sizes');
    }
  }

  /* 🔴 A RELEASE STEP WAS ADDED HERE AND IS WITHDRAWN, because it broke the thing that matters.
     It returned every non-active slide to its responsive candidate, to cap decoded-image memory: one
     1600x1600 original is about 9.8 MB decoded and four were being held at once. MEASURED CONSEQUENCE:
     after sliding away from a slide and back, the ACTIVE image was left un-upgraded - data-drv-savable
     absent and srcset restored - while a non-active slide kept the master. That is precisely the state
     in which a long-press saves the small file, i.e. the fault the owner reported on the iPhone.
     Removed rather than patched, for two reasons: the memory saving was never actually measured -
     restoring the src proves the SOURCE changed, not that the browser freed the decoded bitmap - and
     correctness of the save outranks an unproven optimisation. Only the ACTIVE slide is ever upgraded,
     so the gallery is still never loaded at full size in bulk; a slide already viewed keeps its master. */

  /* 🔴 A ONE-SHOT SWAP IS NOT ENOUGH, measured on the preview theme 2026-10-05. The first version set
     src to the original once and marked the image done. The theme then REWROTE src back to its own
     rendition - the element ended up with srcset correctly removed but
     src="//...&width=1445", which is not a value this file ever writes - and because the image was
     already flagged, nothing retried. The result was a flag saying "savable" over an image that had
     silently reverted to 1445px: exactly the kind of false green this project keeps paying for.
     So the original is ASSERTED, not set: each upgraded image gets its own observer, and any write
     that puts a width-parameterised URL back is corrected. There is no loop, because after a
     correction the src carries no width parameter and the condition is false. */
  function assertOriginal(img, orig) {
    var cur = img.getAttribute('src') || '';
    if (cur === orig) return false;
    if (!/[?&]width=\d+/.test(cur) && cur.indexOf('width=') === -1) {
      /* some other unparameterised value - leave it, it is already full size */
      return false;
    }
    hoistResponsive(img);
    img.setAttribute('src', orig);
    return true;
  }

  function watchImg(img, orig) {
    if (img.__drvWatch) return;
    img.__drvWatch = new MutationObserver(function () {
      if (assertOriginal(img, orig)) {
        /* the element regressed and was corrected; keep the flag truthful either way */
        img.setAttribute('data-drv-savable', '1');
      }
    });
    img.__drvWatch.observe(img, { attributes: true, attributeFilter: ['src', 'srcset', 'sizes'] });
  }

  /* 🔴 THE DECISION IS MADE ON THE src ATTRIBUTE, NEVER ON currentSrc, and that distinction is the
     whole bug this function was rewritten to fix.
     The first version short-circuited when `currentSrc` already looked unparameterised: it removed
     srcset and flagged the image as done WITHOUT setting src. But removing srcset makes the browser
     fall back to the src ATTRIBUTE - which still carried ?width=1445 - so the branch meant to be a
     safe no-op actively DOWNGRADED the image, and the flag then prevented any retry. Measured on the
     preview theme: srcset correctly removed, flag set to 1, and the saved file 1445x1445 instead of
     1600x1600. A control proved the theme was innocent - a manual set of src stuck for 2.5s with no
     counter-write at all, and the only mutation observed was my own.
     So: always preload the original, then set src to it, then verify. No currentSrc shortcuts. */
  function makeSavable(img) {
    if (!img) return;
    var orig = originalOf(img);
    if (!orig) return;
    var srcAttr = img.getAttribute('src') || '';

    /* genuinely already done: the ATTRIBUTE is the original and no candidate list can override it */
    if (srcAttr === orig && !img.hasAttribute('srcset')) {
      img.setAttribute('data-drv-savable', '1');
      watchImg(img, orig);
      return;
    }
    /* 🔴 GIVING UP HERE WAS A REAL DEFECT. Only one original is fetched at a time, and this used to
       `return` when another was in flight - with nothing to retry it. Measured consequence: jumping
       straight to a third slide left it un-upgraded indefinitely, because the one call it got arrived
       while a fetch was pending. The intent hook hits the same path, so a long-press during a pending
       fetch would have silently given up too - which is exactly the iPhone symptom. Retry instead,
       with a single shared timer so rapid swiping cannot stack them. */
    if (pending) {
      if (!retry) {
        retry = setTimeout(function () { retry = null; upgradeActive(); }, 250);
      }
      return;
    }
    var pre = new Image();
    /* 🔴 THE REMAINING WINDOW IS TRANSFER TIME, NOT SCHEDULING, so priority is the only lever left that
       costs nothing. Measured cold at 375x812 on a product never fetched before: the responsive copy
       landed at 3,240ms and the master - 98 KB - only at 4,921ms, a 1,681ms window in which a long-press
       still captures the smaller file. The scheduling delay had already been removed, so that 1,681ms is
       the download itself competing at default priority against everything else still loading.
       Asking for high priority moves the same bytes sooner rather than adding any. It is safe for LCP
       because this fetch only ever starts after the active image has already painted. */
    try { pre.fetchPriority = 'high'; } catch (e) {}
    pending = pre;
    pre.onload = function () {
      pending = null;
      hoistResponsive(img);
      img.setAttribute('src', orig);
      /* flag only once the attribute really holds the original, so the flag cannot lie */
      if ((img.getAttribute('src') || '') === orig) img.setAttribute('data-drv-savable', '1');
      watchImg(img, orig);
    };
    pre.onerror = function () { pending = null; };   /* leave the responsive image exactly as it was */
    pre.src = orig;
  }

  function upgradeActive() {
    var gal = document.querySelector('.gallery-main');
    if (!gal) return;
    var slide = activeSlideIn(gal);
    if (!slide) return;
    makeSavable(slide.querySelector('img.main-image') || slide.querySelector('img'));
  }

  /* 🔴 ON A PHONE THE IDLE WAIT IS THE DEFECT, NOT A PROTECTION. The owner reproduced the fault on an iPhone:
     saving straight from the gallery gave a pixelated file while opening full size first and saving gave a good
     one. The full-size path works because those images are built with the master as their FIRST and ONLY
     resource, whereas the gallery image has already loaded a 550px candidate and is only re-pointed later.
     So the gallery fault is a RACE, and the idle callback is what loses it: a long-press arriving before the
     master has been fetched saves whatever the element still holds.
     Phones are also where saving actually happens, and a phone product page is lighter than the desktop one, so
     on a small viewport the upgrade runs as soon as the active image has loaded instead of queueing behind an
     idle slot. Desktop keeps the idle deferral, where the page is heavier and nobody long-presses. */
  function whenIdle(fn) {
    var narrow = (window.innerWidth || document.documentElement.clientWidth || 0) <= 768;
    if (narrow) { fn(); return; }
    if (window.requestIdleCallback) window.requestIdleCallback(fn, { timeout: 2500 });
    else setTimeout(fn, 1200);
  }

  /* 🔴 THE TWO BUTTONS ARE REMOVED ON PURPOSE. A "download original / view full size" row used to sit
     under the gallery. The owner's requirement is that the ORDINARY save works, so a control that
     works around the ordinary save is not the fix — and that row also competed with the contact
     launcher for the same corner. Any row surviving in a cached page is removed here too, so a
     customer mid-session stops seeing it. */
  function removeFullResRow() {
    var rows = document.querySelectorAll('.drv-fullres');
    for (var i = 0; i < rows.length; i++) if (rows[i].parentNode) rows[i].parentNode.removeChild(rows[i]);
  }

  /* 🔴 THE EARLY WINDOW IS CLOSED AT THE MOMENT OF INTENT, NOT BY WAITING. The deferral below exists
     to protect LCP, but it leaves a window in which the active image is still the responsive
     candidate — measured at 432ms after a slide change on a fast connection, and longer on a slow
     one. That window is NOT uniformly lossy, and the difference matters: slide 1 of the L-Theanine
     gallery already serves the master as its currentSrc (242,459 bytes, byte-identical to the
     original), while the slides whose srcset tops out at width=533 serve 41,576 bytes against a
     170,192-byte 1600x1600 master — a THIRD of the linear resolution. So the exposure is real on
     some slides and absent on others, and a customer must not have to wait an unannounced period to
     find out which.
     Every signal that a save is ABOUT to happen therefore upgrades the active image first:
     pointerdown and touchstart (an iOS long-press BEGINS with one, roughly 500ms before the menu
     appears) and contextmenu (the desktop Save-image-as menu). The two touch signals are PASSIVE
     and NONE of the three calls preventDefault, so long-press, drag, swipe, pinch and the zoom
     control behave exactly as they did. */
  function upgradeOnIntent(gal) {
    var fire = function () { upgradeActive(); };
    gal.addEventListener('pointerdown', fire, { passive: true });
    gal.addEventListener('touchstart', fire, { passive: true });
    gal.addEventListener('contextmenu', fire);
  }

  function startSavable() {
    var gal = document.querySelector('.gallery-main');
    if (!gal || gal.__drvSavable) return;
    gal.__drvSavable = true;

    /* 🔴 START FROM THE ACTIVE IMAGE'S OWN LOAD, NOT THE WHOLE PAGE'S. Measured on a product page at DPR 1:
       the browser picked width=550 for itself at 2,100ms and the master only arrived at 4,787ms, because the
       upgrade waited for window.load at 5,385ms. That left a 2.7-SECOND window in which the displayed image
       was the 550px copy, and on a slow link it is far longer - which is the window a long-press falls into.
       Whichever of the two fires FIRST now starts it, so the same 166 KB is fetched earlier rather than
       additionally. The idle callback is kept so the fetch still yields to the main thread, and the active
       image's own load means its paint - and therefore its LCP contribution - has already happened. */
    var begun = false;
    var begin = function () {
      if (begun) return;
      begun = true;
      whenIdle(upgradeActive);
    };
    if (document.readyState === 'complete') begin();
    else {
      window.addEventListener('load', begin, { once: true });
      var firstSlide = activeSlideIn(gal);
      var firstImg = firstSlide && (firstSlide.querySelector('img.main-image') || firstSlide.querySelector('img'));
      if (firstImg) {
        if (firstImg.complete) begin();
        else firstImg.addEventListener('load', begin, { once: true });
      }
    }

    upgradeOnIntent(gal);

    var sw = gal.swiper;
    /* slideChange fires as the move starts, transitionEnd after it settles; the pending guard in
       makeSavable makes the duplicate call free, and starting earlier shortens the window. */
    if (sw && sw.on) { sw.on('slideChange', upgradeActive); sw.on('slideChangeTransitionEnd', upgradeActive); }
    /* arrow, thumbnail and swipe changes all move the track; observe as a second signal.
       🔴 The readyState gate that used to guard this call is REMOVED: it meant a slide change
       before window.load was ignored entirely, which is exactly the early window this fix closes. */
    new MutationObserver(function () { upgradeActive(); })
      .observe(gal, { attributes: true, subtree: true, attributeFilter: ['class', 'style'] });
  }

  if (document.body.classList.contains('template-product')) {
    removeFullResRow();
    startSavable();
    if (!document.querySelector('.gallery-main')) {
      var mo2 = new MutationObserver(function () {
        if (document.querySelector('.gallery-main')) { mo2.disconnect(); removeFullResRow(); startSavable(); }
      });
      mo2.observe(document.body, { childList: true, subtree: true });
    }
  }
})();
